import { Button, Col, Form, Input, InputNumber, Modal, Row, Select, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import EventEmitter from '../utils/eventEmitter';
import { Badge } from 'flowbite-react';


const MyFooter = ({ handleSell, handleCancel }) => {
  return (
    <div className='flex border-t-2 pt-2'>
      <Button className='me-3' onClick={handleSell} type='primary'>MODIFY</Button>
      <Button onClick={handleCancel} danger>CANCEL</Button>
    </div>
  )
};
const periods = [{value: 'years', label: 'Year(s)'}, {value: 'months', label: 'Month(s)'}, {value: 'week', label: 'Week(s)'}];


const ModifyDepreciation = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  
  const handleCancel = () => setIsModalOpen(false);
  
  const handleOk = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    EventEmitter.subscribe('resume_modify_depreciaion', data => setIsModalOpen(data));
    return () => EventEmitter.unsubscribe('resume_modify_depreciaion');
  },[]);


  
  return (
    <Modal title="Modify Asset" width={900} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={<MyFooter handleCancel={handleCancel} handleSell={handleOk}/>}>
      <Form name="modifyAsset"
        form={form}
        className='border-t-2 py-5' 
        labelAlign='left'
        labelCol={{span: 11}}
        initialValues={{ duration: { number: 1, period: 'years'} }}
        autoComplete="off"
        variant='borderless'
      >
        <Row className='mt-5'>
          <Col lg={{span: 10}}>
            <Badge className="text-slate-500 text-xl bg-transparent	">Modification</Badge>
            <Form.Item label='Reason' name="reason" className='font-semibold text-gray-800 mb-4' required>
              <Input type='text' className='input-outline-none' placeholder='modification reason'/>
            </Form.Item>
          </Col>
          <Col lg={{span: 10, offset:1}}>
            <Badge className="text-slate-500 text-xl bg-transparent	">New Values</Badge>
            <Form.Item label='Duration' className='font-semibold column mb-2' required >
              <Space.Compact>
                <Form.Item name={['duration', 'number']} noStyle>
                  <InputNumber className='input-outline-none font-normal' name='number' />
                </Form.Item>
                <Form.Item name={['duration', 'period']} noStyle>
                  <Select options={periods} className='border-b-2' name='period' style={{width: 100}}/>
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item label='Deprecable Value' name={'deprecable_value'} className='font-semibold mb-2' required >
              <InputNumber className='border-x-0 border-t-0 input-outline-none font-normal w-full'/>
              </Form.Item>
            <Form.Item label="Non Deprecable Value" name="non_deprecable_value" className='font-semibold mb-2' required >
              <InputNumber className='border-2 border-b-2 w-full font-normal' />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default ModifyDepreciation;